import api from "./baseApi";
import endpoints from "./endpoints";

/**
 * Get users with pagination + optional filters
 */
export const getUsers = async (params = {}) => {
  try {
    const res = await api.get(endpoints.user.base, {
      params: {
        page: params.page || 1,
        perPage: params.perPage || 10,
        ...(params.filters || {}),
      },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch users";
    throw new Error(message);
  }
};

/**
 * Get single user by ID
 */
export const getUserById = async (id) => {
  try {
    const res = await api.get(endpoints.user.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch user";
    throw new Error(message);
  }
};

/**
 * Create a new user
 */
export const createUser = async (payload) => {
  try {
    const body = {
      name: payload.name,
      username: payload.username,
      email: payload.email,
      password: payload.password,
      status: payload.status || "active",
      role: payload.role || "staff",
    };

    const res = await api.post(endpoints.user.base, body);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to create user";
    throw new Error(message);
  }
};

/**
 * Update an existing user
 */
export const updateUser = async (id, payload) => {
  try {
    const body = {
      name: payload.name,
      username: payload.username,
      email: payload.email,
      status: payload.status,
      role: payload.role,
    };

    if (payload.password) {
      body.password = payload.password;
    }

    const res = await api.put(endpoints.user.detail(id), body);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update user";
    throw new Error(message);
  }
};

/**
 * Delete a user
 */
export const deleteUser = async (id) => {
  try {
    const res = await api.delete(endpoints.user.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete user";
    throw new Error(message);
  }
};

/**
 * Change user password
 */
export const changeUserPassword = async (id, payload) => {
  try {
    const body = {
      currentPassword: payload.currentPassword,
      newPassword: payload.newPassword,
    };

    const res = await api.post(
      endpoints.user.changePassword(id),
      body
    );

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to change password";
    throw new Error(message);
  }
};